import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: "Greenbrier Inn",
    tagline: "Killington, Vermont Hotel & Gift Shop",
    description: "A 21-room inn and gift shop on Route 4 in Killington, Vermont, five minutes from the ski lifts, with air-conditioned rooms, balconies and a summer pool.",
    placeholder: '',
    url: 'https://greenbriervt.modulify.website',
    ogImage: '/images/greenbrier/inn-exterior-1.jpg',
    ogImageAlt: "The Greenbrier Inn and Gift Shop on Route 4 in Killington, Vermont"
}

/** The G monogram from the inn's own logo, used as a single-colour mask. */
export const brandMark = '/images/greenbrier/logo-mark.gif'

export const contactDetails = {
    legalName: "The Greenbrier Inn & Gift Shop",
    addressLines: ["2057 US Route 4,", "Base of Access Road,", "Killington, Vermont 05751"],
    phone: '802-775-1608',
    phoneHref: 'tel:+18027751608',
    giftShopPhone: '802-775-1575',
    giftShopPhoneHref: 'tel:+18027751575',
    email: 'info@greenbriervt.com',
    emailHref: 'mailto:info@greenbriervt.com',
    established: "Killington, Vermont"
}

export const primaryNav = [
    { label: "Home", href: '/' },
    { label: "About", href: '/about' },
    { label: "Services", href: '/services' },
    { label: "Packages", href: '/packages' },
    { label: "Gallery", href: '/gallery' },
    { label: "News", href: '/news' },
    { label: "Contact", href: '/contact' }
]

export const sitemapLinks = [
    { label: "Home", href: '/' },
    { label: "About", href: '/about' },
    { label: "Services", href: '/services' },
    { label: "Packages", href: '/packages' },
    { label: "Gallery", href: '/gallery' },
    { label: "News", href: '/news' },
    { label: "Contact", href: '/contact' }
]

/** "Stay, Shop, and Ski", the inn's own line. */
export const experienceLinks = [
    { label: "Stay", href: '/#rooms' },
    { label: "Shop", href: '/services#gift-shop' },
    { label: "Ski", href: '/packages' }
]

/** Schema.org description of the business, rendered as JSON-LD on every page. */
export const businessJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Hotel',
    name: contactDetails.legalName,
    alternateName: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    image: `${siteConfig.url}${siteConfig.ogImage}`,
    logo: `${siteConfig.url}${brandMark}`,
    telephone: '+1-802-775-1608',
    email: contactDetails.email,
    numberOfRooms: 21,
    address: {
        '@type': 'PostalAddress',
        streetAddress: "2057 US Route 4",
        addressLocality: "Killington",
        addressRegion: 'VT',
        postalCode: '05751',
        addressCountry: 'US'
    },
    geo: {
        '@type': 'GeoCoordinates',
        latitude: 43.66751461449975,
        longitude: -72.8088641166687
    },
    amenityFeature: [
        "Air conditioning",
        "Continental breakfast",
        "Wireless internet in common areas",
        "Outdoor swimming pool (summer)",
        "Hiking trails",
        "Snowshoeing",
        "Home decor and gift shop"
    ].map((name) => ({ '@type': 'LocationFeatureSpecification', name, value: true }))
}
